export const svgCanvasConfig = {
    canvasName: "default",
    canvas_expansion: 1.5,
    initFill: {
        color: "FF0000",
        opacity: 1,
    },
    initStroke: {
        width: 5,
        color: "000000",
        opacity: 1,
    },
    text: {
        stroke_width: 0,
        font_size: 24,
        font_family: "serif",
    },
    initOpacity: 1,
    colorPickerCSS: null,
    initTool: "select",
    exportWindowType: "new",
    wireframe: false,
    showlayers: false,
    no_save_warning: false,
    langPath: "locale/",
    extPath: "extensions/",
    canvgPath: "canvg/",
    jspdfPath: "jspdf/",
    imgPath: "images/",
    jGraduatePath: "jgraduate/images/",
    extIconsPath: "extensions/",
    dimensions: [800, 600],
    gridSnapping: false,
    gridColor: "#000",
    baseUnit: "px",
    snappingStep: 10,
    showRulers: false,
    showGrid: false,
};
